<template>
  <div class="align-items-center justify-content-center activityPopup">
    <div class="popup-container">
      <transition name="bounce">
        <div v-show="open" class="phone-view-wrapper justify-content-center">
          <div class="phone-view col-lg-8">
            <button class="btn close-button" v-on:click="closeClicked"/>

            <div class="phone col-6"></div>
            <div class="info col-6">
              <div class="info-window">
                {{ getRandomText() }}
              </div>
              <WhiteOutlineButton button-text="ACTIVITEIT BEKIJKEN" :style="{height: '10%'}"
                                  v-on:clicked="showActivity"></WhiteOutlineButton>
            </div>

          </div>

        </div>
      </transition>

    </div>
  </div>

</template>

<script>

  import WhiteOutlineButton from "@/components/StudentPlatform/WhiteOutlineButton";

  export default {
    name: "PhoneView",
    components: {WhiteOutlineButton},
    props: {
      name: String,
      open: Boolean,
      buddyName: String,
    },
    data() {
      return {
        show: this.open,
        textStrings: [
          "Dag klas, ik heb een toffe beweegopdracht voor jullie en [buddyName]. Zijn jullie er klaar voor?",
          "Hoi, gaan we samen met [buddyName] een nieuwe uitdaging aan? Hebben jullie er zin in?",
          "Hey, we gaan samen met [buddyName] een leuke opdracht uitvoeren. Doen jullie mee?",
          "Dag klas, zin om samen met [buddyName] een toffe opdracht te doen? We gaan ervoor!",
          "Hoi, [buddyName] en ik hebben een leuke opdracht voorzien? Hebben jullie er zin in?",
          "Dag klas, doen we samen met [buddyName] een nieuwe opdracht? We gaan ervoor!",
        ]
      }
    },
    computed: {},
    mixins: [],
    methods: {
      showActivity() {
        this.$emit("showActivity");
      },

      closeClicked() {
        this.$emit("closeClicked");
      },

      getRandomText() {
        let text = this.textStrings[Math.floor(Math.random() * this.textStrings.length)];
        text = text.replace('[buddyName]', this.buddyName);
        return text;
      },

    },
    mounted() {

    },
    created() {
    },
  }


</script>

<style lang="scss" scoped>

  .activityPopup {
    width: 100vw;
    height: 100vh;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    top: 0;
    left: 0;
    display: flex;

    .popup-container {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .phone-view {
    display: flex;
    justify-content: space-between;
  }

  .phone-view-wrapper {
    display: flex;
    flex-direction: row;
    min-width: 80%;
    min-height: 70%;
  }

  .phone, .info {
    width: 45%;
    height: 100%;
  }

  .phone {
    background-image: $phone;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }

  .info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .info-window {
    max-height: 60%;
    padding: 30px;
    background-color: white;
    margin-bottom: 20px;
    overflow-y: scroll;
    color: $phone-message-font-color;
    font-size: 1.4rem;

    p {


      .emphasis {
        font-weight: bold;
        color: $phone-message-font-emphasis;
      }
    }
  }

  .close-button {
    width: 50px;
    height: 50px;
    position: absolute;
    right: 2%;
    top: 2%;
    background-image: url("~@/assets/image/button/bb_button_close.svg");
    z-index: 3;
  }

  .bounce-enter-active {
    animation: bounce-in .5s;
  }

  .bounce-leave-active {
    animation: bounce-in .5s reverse;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

</style>